module.exports = __webpack_public_path__ + "img/promis.9c08e8eb.png";